import { FC, ReactNode } from 'react';
import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  SystemStyleObject
} from '@chakra-ui/react';
import { tw } from '@utils/tailwind-utils';

interface ItemProps {
  title: ReactNode;
  titleClasses?: string;
  description: ReactNode;
  sxStyles?: SystemStyleObject;
  textClasses?: string;
  buttonSx?: SystemStyleObject;
  accordionSx?: SystemStyleObject;
  paneSx?: SystemStyleObject;
}

const Item: FC<ItemProps> = ({
  title,
  titleClasses,
  description,
  sxStyles,
  textClasses,
  buttonSx,
  accordionSx,
  paneSx
}) => {
  return (
    <AccordionItem
      sx={{
        pb: 4,
        borderTop: 'unset',
        borderBottom: '1px solid #E5E5E5',
        ...sxStyles
      }}
    >
      {({ isExpanded }) => (
        <>
          <h2 className={titleClasses}>
            <AccordionButton
              sx={{
                '&:hover': {
                  bg: 'unset'
                },
                px: 0,
                backgrounColor: 'red',
                ...buttonSx
              }}
            >
              <Box
                as="span"
                flex="1"
                textAlign="left"
                sx={{
                  ...(isExpanded && { color: 'rentennials.primary' }),
                  pr: 2
                }}
              >
                <span className={tw('font-bree-serif text-[15px] font-normal tablet:text-[18px]', textClasses)}>
                  {title}
                </span>
              </Box>
              <AccordionIcon
                sx={{
                  fontSize: '28px',
                  ...(isExpanded && { color: 'rentennials.primary' }),
                  ...accordionSx
                }}
              />
            </AccordionButton>
          </h2>
          <AccordionPanel
            sx={{
              pl: 0,
              pr: 0,
              ...paneSx
            }}
          >
            {description}
          </AccordionPanel>
        </>
      )}
    </AccordionItem>
  );
};

export default Item;
